/**
 * Kompatybilna fasada geokodowania — wywołuje Edge Function `geocode-address`.
 * Nie używa już bezpośrednio nominatim.openstreetmap.org z przeglądarki.
 */
import { resolveAddress, searchAddresses, lookupPlace } from './geocodeEdge';

class NominatimGeocodingService {
  isConfigured() {
    return true;
  }

  async autocomplete(input, options = {}) {
    void options;
    /* Ograniczenie kraju: `src/config/geocodeRegion.js` + Edge `countrycodes` (nie Google `componentRestrictions`). */
    return searchAddresses(input, options);
  }

  async getPlaceDetails(placeId, options = {}) {
    void options;
    const key = String(placeId);
    const cached = NominatimGeocodingService._latLngCache?.get(key);
    if (cached) {
      return this._placeFromLatLng(cached.lat, cached.lng, cached.address);
    }
    const place = await lookupPlace(key);
    const lat =
      typeof place.geometry.location.lat === 'function'
        ? place.geometry.location.lat()
        : place.geometry.location.lat;
    const lng =
      typeof place.geometry.location.lng === 'function'
        ? place.geometry.location.lng()
        : place.geometry.location.lng;
    NominatimGeocodingService._latLngCache?.set(key, {
      lat,
      lng,
      address: place.formatted_address,
    });
    return place;
  }

  _placeFromLatLng(lat, lng, formatted_address) {
    return {
      formatted_address: formatted_address || `${lat}, ${lng}`,
      geometry: {
        location: {
          lat: () => lat,
          lng: () => lng,
        },
      },
      place_id: null,
    };
  }

  async geocodeAddress(address, options = {}) {
    void options;
    const q = (address || '').trim();
    if (!q) return null;
    const result = await resolveAddress(q);
    if (!result) return null;
    return {
      address: result.address,
      lat: result.lat,
      lng: result.lng,
      placeId: '',
    };
  }
}

NominatimGeocodingService._latLngCache = new Map();

export const geoSearchService = new NominatimGeocodingService();
